import Flickity from 'flickity';
import * as TWTmediaQuery from './twt.media-query';

const blnIsTouchDevice = !!('ontouchstart' in window) || !!(navigator.msMaxTouchPoints);
const FlickityDefaults = {
  cellSelector: '.slide',
  cellAlign: 'left',
  contain: true,
  draggable: blnIsTouchDevice,
  dragThreshold: 10,
  groupCells: true,
};

/**
 * @param  {JQuery} element jQuery object
 * @param  {Object} options option parameters
 * @return {void}
 */
function initFlickity(element, options) {
  const config = Object.assign(FlickityDefaults, options);
  const flkty = new Flickity(element, config);
  const customEvent = document.createEvent('Event');

  flkty.slider.style.display = 'flex';

  flkty.cells.forEach((cell) => {
    cell.element.style.position = ''; // eslint-disable-line no-param-reassign
    cell.element.style.left = ''; // eslint-disable-line no-param-reassign
  });

  // init custom event
  customEvent.initEvent('resize', false, true);

  // dispatch custom event
  window.dispatchEvent(customEvent);

  return flkty;
}

window.onload = () => {
  const teaserSlider = [].slice.call(document.querySelectorAll('.slider--teaser'));

  if (teaserSlider !== null) {
    const sliderInstances = [];

    teaserSlider.forEach((slider) => {
      initFlickity(slider);

      sliderInstances.push(slider);
    });
  }

  if (document.querySelectorAll('.slider--image') !== null) {
    const sliderNodes = document.querySelectorAll('.slider--image');
    const sliderInstances = [];

    for (let i = 0; i < sliderNodes.length; i += 1) {
      const element = sliderNodes[i];
      sliderInstances.push(initFlickity(element, {
        cellAlign: 'center',
      }));
    }
  }

  if (document.querySelectorAll('.slider--mobile') !== null) {
    const sliderNodes = document.querySelectorAll('.slider--mobile');
    const strCurrentSize = TWTmediaQuery.getCurrentSize();
    let sliderInstances = [];

    if (strCurrentSize === 'xs' || strCurrentSize === 's') {
      for (let i = 0; i < sliderNodes.length; i += 1) {
        const element = sliderNodes[i];
        sliderInstances.push(initFlickity(element));
      }
    }

    window.addEventListener('changed.twt.mediaQuery', (event) => {
      const newSize = event.detail.newSize;

      if ((newSize !== 'xs' && newSize !== 's')) {
        for (let i = 0; i < sliderInstances.length; i += 1) {
          const element = sliderInstances[i];
          element.flickity('destroy');
        }
        sliderInstances = [];
      } else if ((newSize === 'xs' || newSize === 's')) {
        for (let i = 0; i < sliderNodes.length; i += 1) {
          const element = sliderNodes[i];
          sliderInstances.push(initFlickity(element));
        }
      }
    });
  }
};



// WEBPACK FOOTER //
// ./assets/js/components/slider.js